// LogoLarge.jsx

import React from 'react';

// CSS
import './LogoLarge.css';

// Icons
import logolarge from 'images/logolarge_grayscale.png';

/**
 * LogoLarge Component
 * 
 * This component renders a large version of the app logo.
 * 
 * @returns {ReactNode} LogoLarge component.
 */
const LogoLarge = () => {

  return (
    <div className="logo-large-container">

      {/* IMAGE */}
      <img
        className="logo-large-orbital-image"
        src={logolarge}
        alt="Orbital Logo"
      />

    </div>
  );
};

export default LogoLarge;

